  window.interdeal = {
  "sitekey": "d369edba87bbb566afaa3978df9f2dbd",
  "Position": "left",
  "domains": {
  "js": "https://js.nagich.co.il/",
  "acc": "https://access.nagich.co.il/"
},
  "Menulang": "HE",
  "btnStyle": {
  "vPosition": [
  "80%",
  "20%"
  ],
  "scale": [
  "0.5",
  "0.5"
  ],
  "color": {
  "main": "#016e9d",
  "second": "#ffffff"
},
  "icon": {
  "outline": true,
  "type": 11,
  "shape": "circle"
}
}
};
  (function(doc, head, body){
  var coreCall             = doc.createElement('script');
  coreCall.src             = interdeal.domains.js + 'core/5.0.3/accessibility.js';
  coreCall.defer           = true;
  coreCall.integrity       = 'sha512-pBNj4i59IbemIH/QQW+Y4xjraCnK4GSp9A04+TNuX3jETJiWjstB5g4o7OA/B8NNXn7/xbFCisjUXBX0+TGEIA==';
  coreCall.crossOrigin     = 'anonymous';
  coreCall.setAttribute('data-cfasync', true );
  body? body.appendChild(coreCall) : head.appendChild(coreCall);
})(document, document.head, document.body);


// var is_accessibility_open = !1,
//     accessibility_rtl = !0,
//     pixel_from_start = 50,
//     pixel_from_side = 10,
//     css_style = 1,
//     is_contrast_yellow = !1,
//     is_contrast_blue = !1,
//     is_animation_blocked = !1,
//     is_links_underline = !1,
//     is_readable_font = !1,
//     is_gray_images = !1,
//     is_set_for_mobile = !1,
//     hide_header_text = !1;
// function StartAccessibility() {
//     if (is_accessibility_open) jQuery(".btn_accessibility_action").css("top", pixel_from_start + "px"), jQuery(".btn_accessibility_action").css("visibility", "hidden"), (is_accessibility_open = !1);
//     else {
//         var e = "42px",
//             t = "280px",
//             i = 49,
//             a = 47;
//         is_set_for_mobile && (jQuery("html, body").animate({ scrollTop: 0 }, 50), (e = "34px"), (t = "260px"), (a = 38), (i = 40)),
//             jQuery(".btn_accessibility_action").css("visibility", "visible"),
//             jQuery("#accessibility_action1").animate({ top: pixel_from_start + i }, 0, function () {
//                 jQuery("#accessibility_action1").css("width", t), jQuery("#accessibility_action1").css("height", e), jQuery("#accessibility_action1").css("top", pixel_from_start + i + "px");
//             }),
//             jQuery("#accessibility_action2").animate({ top: pixel_from_start + i + a }, 40, function () {
//                 jQuery("#accessibility_action1").css("width", t),
//                     jQuery("#accessibility_action1").css("height", e),
//                     jQuery("#accessibility_action1").css("top", pixel_from_start + i + "px"),
//                     jQuery("#accessibility_action2").css("width", t),
//                     jQuery("#accessibility_action2").css("height", e),
//                     jQuery("#accessibility_action2").css("top", pixel_from_start + i + a + "px");
//             }),
//             jQuery("#accessibility_action3").animate({ top: pixel_from_start + i + 2 * a }, 80, function () {
//                 jQuery("#accessibility_action3").css("width", t), jQuery("#accessibility_action3").css("height", e), jQuery("#accessibility_action3").css("top", pixel_from_start + i + 2 * a + "px");
//             }),
//             jQuery("#accessibility_action4").animate({ top: pixel_from_start + i + 3 * a }, 120, function () {
//                 jQuery("#accessibility_action4").css("width", t), jQuery("#accessibility_action4").css("height", e), jQuery("#accessibility_action4").css("top", pixel_from_start + i + 3 * a + "px");
//             }),
//             jQuery("#accessibility_action10").animate({ top: pixel_from_start + i + 4 * a }, 160, function () {
//                 jQuery("#accessibility_action10").css("width", t), jQuery("#accessibility_action10").css("height", e), jQuery("#accessibility_action10").css("top", pixel_from_start + i + 4 * a + "px");
//             }),
//             jQuery("#accessibility_action5").animate({ top: pixel_from_start + i + 5 * a }, 200, function () {
//                 jQuery("#accessibility_action5").css("width", t), jQuery("#accessibility_action5").css("height", e), jQuery("#accessibility_action5").css("top", pixel_from_start + i + 5 * a + "px");
//             }),
//             jQuery("#accessibility_action6").animate({ top: pixel_from_start + i + 6 * a }, 240, function () {
//                 jQuery("#accessibility_action6").css("width", t), jQuery("#accessibility_action6").css("height", e), jQuery("#accessibility_action6").css("top", pixel_from_start + i + 6 * a + "px");
//             }),
//             jQuery("#accessibility_action7").animate({ top: pixel_from_start + i + 7 * a }, 280, function () {
//                 jQuery("#accessibility_action7").css("width", t), jQuery("#accessibility_action7").css("height", e), jQuery("#accessibility_action7").css("top", pixel_from_start + i + 7 * a + "px");
//             }),
//             jQuery("#accessibility_action11").animate({ top: pixel_from_start + i + 8 * a }, 320, function () {
//                 jQuery("#accessibility_action11").css("width", t), jQuery("#accessibility_action11").css("height", e), jQuery("#accessibility_action11").css("top", pixel_from_start + i + 8 * a + "px");
//             }),
//             jQuery("#accessibility_action9").animate({ top: pixel_from_start + i + 9 * a }, 360, function () {
//                 jQuery("#accessibility_action9").css("width", t), jQuery("#accessibility_action9").css("height", e), jQuery("#accessibility_action9").css("top", pixel_from_start + i + 9 * a + "px");
//             }),
//             jQuery("#accessibility_action8").animate({ top: pixel_from_start + i + 10 * a }, 400, function () {
//                 jQuery("#accessibility_action8").css("width", t), jQuery("#accessibility_action8").css("height", e), jQuery("#accessibility_action8").css("top", pixel_from_start + i + 10 * a + "px");
//             }),
//             (is_accessibility_open = !0);
//     }
// }
// function setCookie(e, t, i) {
//     var a = new Date();
//     a.setTime(a.getTime() + 24 * i * 60 * 60 * 1e3);
//     var n = "expires=" + a.toUTCString();
//     document.cookie = e + "=" + t + "; " + n;
// }
// function getCookie(e) {
//     for (var t = e + "=", i = document.cookie.split(";"), a = 0; a < i.length; a++) {
//         for (var n = i[a]; " " == n.charAt(0); ) n = n.substring(1);
//         if (0 == n.indexOf(t)) return n.substring(t.length, n.length);
//     }
//     return "";
// }
// function isElHasAttr(e, t) {
//     return void 0 !== e.getAttribute(t);
// }
// var fps = "";
// try {
//     var fp = new Fingerprint2();
//     fp.get(function (e, t) {
//         fps = e;
//     });
// } catch (e) {
//     fps = "";
// }
// jQuery(document).ready(function (e) {
//     try {
//         (e(window).width() < 991 || DetectMobile()) && (is_set_for_mobile = !0),
//             AddCssClasses(),
//             "" != fps
//                 ? SetAccessibilityComponent()
//                 : setTimeout(function () {
//                     CheckToSetAccessibilityComponent();
//                 }, 40),
//             KeepFontSizeDefault();
//     } catch (e) {
//         console.log(e);
//     }
//     setTimeout(function () {
//         CheckSelectedOptionsFromCookies();
//     }, 500);
// });
// var negishim_base = "https://www.negishim.com/accessibility/",
//     checkes = 0;
// function CheckToSetAccessibilityComponent() {
//     checkes++,
//         "" != fps || 50 < checkes
//             ? SetAccessibilityComponent()
//             : setTimeout(function () {
//                 CheckToSetAccessibilityComponent();
//             }, 40);
// }
// function jsonpCallback(e) {
//     null == e ||
//     jQuery(
//         '<iframe  src="' +
//         (negishim_base + "ls.aspx?ials=" + e) +
//         '" style="position:absolute;top:-999px;overflow:hidden;height:1px;width:1px;margin:-1px;padding:0;border:0;" width="1" height="1" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" topmargin="0" leftmargin="0">'
//     ).appendTo("body");
// }
// function SetAccessibilityComponent() {
//     var e = "",
//         t = "black",
//         i = "#000000";
//     2 == css_style && ((t = "white"), (i = "#ffffff")),
//         (e += '<!--noindex-->'),
//         (e += "<div  class='accessibility_component accessibility_div_wrap' style='display:none;position:relative;z-index:2147483646;'>"),
//         (e += "<a role='button' tabindex='1' href='javascript:void(0);'  class='btn_accessibility accessibility_component' title='לחץ להפעלת אפשרויות נגישות'>"),
//     !is_set_for_mobile & !hide_header_text && (e += "<span class='accessibility_component'>נגישות</span> ");
//     var a = window.location.href.replace("?", "^").replace(/&/g, "~");
//   (e +=
//     '<img id="accessibility_icon" width="18" height="18" loading="lazy" decoding="async" src="' +
//     negishim_base +
//     'wheelchair.ashx?is_pro=1' +
//     '&v=255&css_style=' +
//     css_style +
//     '" alt="נגישות" class="accessibility_component" aria-hidden=\'true\'/>'),
//     (e += '</a>'),
//     (e += '<div id="accessibility_action1" class="btn_accessibility_action accessibility_component" style="z-index:2147483646;" title="תפריט נגישות" aria-hidden=\'true\'>'),
//     (e += '<img src="' + negishim_base + 'menu_18_' + t + '.png" alt="menu" class="accessibility_component" width="18" height="18" loading="lazy" decoding="async" aria-hidden=\'true\'/>'),
//     (e += ' תפריט נגישות'),
//     (e += '</div>'),
//     (e += '<div id="accessibility_action2" class="btn_accessibility_action accessibility_component" style="padding-top:' + (is_set_for_mobile ? '2px' : '6px') + ' !important;z-index:2147483645;" title="גודל טקסט">'),
//     (e += '<img src="' + negishim_base + 'font_size_18_' + t + '.png" alt="menu" width="18" height="18" loading="lazy" decoding="async" class="accessibility_component" style="margin-top:6px;"/>'),
//     (e +=
//       ' <a role="button" tabindex="2" href="javascript:void(0);" title="גודל טקסט רגיל" id="a_fs_d" onclick="FontSizeDefault();return false;" class="accessibility_component a_gray" style="font-weight:bold!important;display:inline;font-size:20px !important;font-family:arial !important;text-decoration:none;color:' +
//       i +
//       ';vertical-align:baseline !important;"><span class="accessibility_component" aria-hidden=\'true\' style="font-size:20px !important;">א</span></a> &nbsp; '),
//     (e +=
//       ' <a role="button" tabindex="3" href="javascript:void(0);" title="הגדלת טקסט רמה 1" id="a_fs_m" onclick="FontSizeM();return false;" class="accessibility_component a_gray" style="font-weight:bold!important;display:inline;font-size:22px !important;font-family:arial !important;text-decoration:none;color:' +
//       i +
//       ';vertical-align:baseline !important;"><span class="accessibility_component" aria-hidden=\'true\' style="font-size:22px !important;">א</span></a> &nbsp; '),
//     (e +=
//       ' <a role="button" tabindex="4" href="javascript:void(0);" title="הגדלת טקסט רמה 2" id="a_fs_l" onclick="FontSizeL();return false;" class="accessibility_component a_gray" style="font-weight:bold!important;display:inline;font-size:24px !important;font-family:arial !important;text-decoration:none;color:' +
//       i +
//       ';vertical-align:baseline !important;"><span class="accessibility_component" aria-hidden=\'true\' style="font-size:24px !important;">א</span></a> &nbsp; '),
//     (e +=
//       ' <a role="button" tabindex="5" href="javascript:void(0);" title="הגדלת טקסט רמה 3" id="a_fs_xl" onclick="FontSizeXl();return false;" class="accessibility_component a_gray" style="font-weight:bold!important;display:inline;font-size:26px !important;font-family:arial !important;text-decoration:none;color:' +
//       i +
//       ';vertical-align:baseline !important;"><span class="accessibility_component" aria-hidden=\'true\' style="font-size:26px !important;">א</span></a>'),
//     (e += '</div>'),
//     (e +=
//       '<a role="button" tabindex="6" id="accessibility_action3" href="javascript:void(0);" onclick="AccessibilityContrastBlackOnBlue();return false;" class="btn_accessibility_action accessibility_component" style="z-index:2147483644;" title="ניגודיות עדינה">'),
//     (e += '<img src="' + negishim_base + 'contrast_18_' + t + '.png" alt="contrast" width="18" height="18" loading="lazy" decoding="async" class="accessibility_component" style="border:0" aria-hidden=\'true\'/>'),
//     (e += '<span class="accessibility_component" aria-hidden=\'true\' >ניגודיות עדינה</span>'),
//     (e += '</a>'),
//     (e +=
//       '<a role="button" tabindex="7" id="accessibility_action4" href="javascript:void(0);" onclick="AccessibilityContrastYellowOnBlack();return false;" class="btn_accessibility_action accessibility_component" style="z-index:2147483643;" title="ניגודיות גבוהה">'),
//     (e += '<img src="' + negishim_base + 'contrast_18_' + t + '.png" alt="contrast" width="18" height="18" loading="lazy" decoding="async" class="accessibility_component" style="border:0" aria-hidden=\'true\'/>'),
//     (e += '<span class="accessibility_component" aria-hidden=\'true\'>ניגודיות גבוהה</span>'),
//     (e += '</a>'),
//     (e +=
//       '<a role="button" tabindex="8" id="accessibility_action10" href="javascript:void(0);" onclick="GrayImages();return false;" class="btn_accessibility_action accessibility_component" style="z-index:2147483642;" title="ביטול צבעים והצגת האתר בגווני שחור לבן">'),
//     (e += '<img src="' + negishim_base + 'gray_images_18_' + t + '.png" alt="gray images" width="18" height="18" loading="lazy" decoding="async" class="accessibility_component" style="border:0" aria-hidden=\'true\'/>'),
//     (e += '<span class="accessibility_component" aria-hidden=\'true\'>מונוכרום</span>'),
//     (e += '</a>'),
//     (e +=
//       '<a role="button" tabindex="9" id="accessibility_action5" href="javascript:void(0);" onclick="LinksUnderline();return false;" class="btn_accessibility_action accessibility_component" style="z-index:2147483641;" title="הדגשת קישורים - הצגת קו תחתי מתחת לקישורים">'),
//     (e += '<img src="' + negishim_base + 'underline_18_' + t + '.png" alt="underline" width="18" height="18" loading="lazy" decoding="async" class="accessibility_component" style="border:0" aria-hidden=\'true\'/>'),
//     (e += '<span class="accessibility_component" aria-hidden=\'true\'>הדגשת קישורים</span>'),
//     (e += '</a>'),
//     (e +=
//       '<a role="button" tabindex="10" id="accessibility_action6" href="javascript:void(0);" onclick="BlockAnimation();return false;" class="btn_accessibility_action accessibility_component" style="z-index:2147483640;" title="חסימת אנימציה">'),
//     (e += '<img src="' + negishim_base + 'eye_blocked_18_' + t + '.png" alt="eye_blocked" width="18" height="18" loading="lazy" decoding="async" class="accessibility_component" style="border:0" aria-hidden=\'true\'/>'),
//     (e += '<span class="accessibility_component" aria-hidden=\'true\'>חסימת אנימציה</span>'),
//     (e += '</a>'),
//     (e +=
//       '<a role="button" tabindex="11" id="accessibility_action7" href="javascript:void(0);" onclick="ReadableFont();return false;" class="btn_accessibility_action accessibility_component" style="z-index:2147483639;" title="שנה את פונט האתר לפונט קריא יותר">'),
//     (e += '<img src="' + negishim_base + 'font_18_' + t + '.png" alt="font" width="18" height="18" loading="lazy" decoding="async" class="accessibility_component" style="border:0" aria-hidden=\'true\'/>'),
//     (e += '<span class="accessibility_component" aria-hidden=\'true\'>פונט קריא</span>'),
//     (e += '</a>'),
//     (e +=
//       '<a role="button" tabindex="12" id="accessibility_action11" href="javascript:void(0);" onclick="StartAccessibility();return false;" class="btn_accessibility_action accessibility_component" style="z-index:2147483638;" title="סגור רכיב נגישות">'),
//     (e += '<img src="' + negishim_base + 'close_18_' + t + '.png" alt="close" width="18" height="18" loading="lazy" decoding="async" class="accessibility_component" style="border:0" aria-hidden=\'true\'/>'),
//     (e += '<span class="accessibility_component" aria-hidden=\'true\'>סגור</span>'),
//     (e += '</a>'),
//     (e +=
//       '<a role="button" tabindex="13" id="accessibility_action9" href="javascript:void(0);" onclick="AccessibilityReset();return false;" class="btn_accessibility_action accessibility_component" style="z-index:2147483637;" title="איפוס הגדרות נגישות למצב ברירת מחדל">'),
//     (e += '<img src="' + negishim_base + 'power_off_18_' + t + '.png" alt="power off" width="18" height="18" loading="lazy" decoding="async" class="accessibility_component" style="border:0" aria-hidden=\'true\'/>'),
//     (e += '<span class="accessibility_component" aria-hidden=\'true\'>איפוס הגדרות נגישות</span>'),
//     (e += '</a>'),
//     (e +=
//       '<a role="button" tabindex="14" id="accessibility_action8" href="http://www.negishim.org/" target="_blank" class="btn_accessibility_action accessibility_component btn_accessibility_action_active" style="z-index:2147483636;" title="להורדת מודול נגישות חינם">'),
//     (e += '<img src="' + negishim_base + 'info_18_' + t + '.png" alt="info" width="18" height="18" loading="lazy" decoding="async" class="accessibility_component" style="border:0" aria-hidden=\'true\'/>'),
//     (e += '<span class="accessibility_component" aria-hidden=\'true\'>להורדת מודול נגישות חינם</span>'),
//     (e += '</a>'),
//     (e += '</div>'),
//     (e += '<!--/noindex-->')
//         jQuery("body").append(e);
//     var n = 0;
//     try {
//         n = jQuery.fn.jquery;
//     } catch (e) {
//         n = 0;
//     }
//     if (3 <= n[0]) {
//         var o = jQuery("#accessibility_icon")[0];
//         jQuery("<img/>")
//             .attr("src", jQuery(o).attr("src"))
//             .on("load", function () {
//                 if (18 == this.width) {
//                     jQuery(".accessibility_div_wrap").css("display", "block");
//                     var e = new Date().getTime();
//                     //jQuery.ajax({ url: negishim_base + "ls.ashx?ii=" + e, type: "get", contentType: "application/json", dataType: "jsonp", crossDomain: !0, crossOrigin: !0, jsonpCallback: "jsonpCallback", success: function (e, t, i) {} });
//                 }
//             });
//     } else {
//         o = jQuery("#accessibility_icon")[0];
//         jQuery("<img/>")
//             .attr("src", jQuery(o).attr("src"))
//             .load(function () {
//                 if (18 == this.width) {
//                     jQuery(".accessibility_div_wrap").css("display", "block");
//                     var e = new Date().getTime();
//                     //jQuery.ajax({ url: negishim_base + "ls.ashx?ii=" + e, type: "get", contentType: "application/json", dataType: "jsonp", crossDomain: !0, crossOrigin: !0, jsonpCallback: "jsonpCallback", success: function (e, t, i) {} });
//                 }
//             });
//     }
//   $("a.btn_accessibility").on("click", function () {
//     StartAccessibility();
//     return false;
//   })
//   $("#a_fs_d").on("click", function () {
//     FontSizeDefault();
//     return false;
//   })
//   $("#a_fs_m").on("click", function () {
//     FontSizeM();
//     return false;
//   })
//   $("#a_fs_l").on("click", function () {
//     FontSizeL();
//     return false;
//   })
//   $("#a_fs_xl").on("click", function () {
//     FontSizeXl();
//     return false;
//   })
//   $("#accessibility_action3").on("click", function () {
//     AccessibilityContrastBlackOnBlue();
//     return false;
//   })
//   $("#accessibility_action4").on("click", function () {
//     AccessibilityContrastYellowOnBlack();
//     return false;
//   })
//   $("#accessibility_action10").on("click", function () {
//     GrayImages();
//     return false;
//   })
//   $("#accessibility_action5").on("click", function () {
//     LinksUnderline();
//     return false;
//   })
//   $("#accessibility_action6").on("click", function () {
//     BlockAnimation();
//     return false;
//   })
//   $("#accessibility_action7").on("click", function () {
//     ReadableFont();
//     return false;
//   })
//   $("#accessibility_action11").on("click", function () {
//     StartAccessibility();
//     return false;
//   })
//   $("#accessibility_action9").on("click", function () {
//     AccessibilityReset();
//     return false;
//   })
// }
// function CheckSelectedOptionsFromCookies() {
//     try {
//         switch (getCookie("accessibility_font_size")) {
//             case "m":
//                 (current_font_size_level = 2), FontSizeM();
//                 break;
//             case "l":
//                 (current_font_size_level = 3), FontSizeL();
//                 break;
//             case "xl":
//                 (current_font_size_level = 4), FontSizeXl();
//         }
//     } catch (e) {}
//     try {
//         switch (getCookie("accessibility_contrast")) {
//             case "yellow":
//                 AccessibilityContrastYellowOnBlack();
//                 break;
//             case "blue":
//                 AccessibilityContrastBlackOnBlue();
//         }
//     } catch (e) {}
//     try {
//         "1" == getCookie("links_underline") && LinksUnderline();
//     } catch (e) {}
//     try {
//         "1" == getCookie("readable_font") && ReadableFont();
//     } catch (e) {}
//     try {
//         "1" == getCookie("is_animation_blocked") && BlockAnimation();
//     } catch (e) {}
//     try {
//         "1" == getCookie("gray_images") && GrayImages();
//     } catch (e) {}
// }
// function AddCssClasses() {
//   try {
//     var e = '#000000',
//       t = '#ffffff',
//       i = '#E5E5E5',
//       a = '#EBEBEB',
//       n = '',
//       o = 'gray';
//     2 == css_style && ((e = '#ffffff'), (t = '#000000'), (a = i = '#2A2A2A'), (o = '#C0C0C0'), (n = 'border:1px solid #2A2A2A;'));
//     var s = document.createElement('style');
//     s.type = 'text/css';
//     var r = '18px!important';
//     (is_set_for_mobile || hide_header_text) && ((r = '16px!important'), !is_set_for_mobile && hide_header_text && (r = '16px!important'));
//     var c = '',
//       l = 'height:42px;font-size:' + r + ';padding:12px 10px 0px 0px;',
//       d = 'padding:10px 10px 0px 0px;width:92px;height:40px;';
//     (is_set_for_mobile || hide_header_text) &&
//     ((l = 'height:34px;font-size:' + r + ';padding:8px 10px 0px 0px;'),
//       (d = 'padding:8px 6px 0px 0px;width:34px;height:34px;'),
//     !is_set_for_mobile && hide_header_text && ((l = 'height:42px;font-size:' + r + ';padding:12px 10px 0px 0px;'), (d = 'padding:12px 10px 0px 0px;width:42px;height:40px;'))),
//       (c +=
//         '.btn_accessibility {' +
//         d +
//         n +
//         'color:' +
//         e +
//         ' !important;background-color: ' +
//         t +
//         ' !important;text-decoration:none;top:' +
//         pixel_from_start +
//         'px;display: inline-block;border-radius:6px;overflow: hidden;position: fixed!important;' +
//         (accessibility_rtl ? 'right' : 'left') +
//         ':' +
//         pixel_from_side +
//         'px;z-index: 2147483647;box-sizing: border-box;text-align: right;margin: 0 auto;-webkit-transition: all 0.3s;transition: all 0.3s;-webkit-box-shadow: 0px 0px 5px 0px #000000;-moz-box-shadow: 0px 0px 5px 0px #000000;box-shadow: 0px 0px 5px 0px #000000;font-weight:normal;font-size:18px!important;direction:rtl;}'),
//       (c += '.btn_accessibility span{font-size:18px!important;}'),
//       (c += '.btn_accessibility img{vertical-align:top;width:auto;}'),
//       (c +=
//         '.btn_accessibility:hover,.btn_accessibility:focus{font-size:18px;background-color:' +
//         i +
//         ' !important;text-decoration:underline;-webkit-box-shadow: 0px 0px 5px 1px #757575;-moz-box-shadow: 0px 0px 5px 1px #757575;box-shadow: 0px 0px 5px 1px #757575;outline:0;}'),
//       (c += '.btn_accessibility:hover strong,.btn_accessibility:focus strong{right:20px;color:yellow !important;}'),
//       (c +=
//         '.btn_accessibility_action {' +
//         l +
//         n +
//         'color:' +
//         e +
//         ' !important;background-color: ' +
//         t +
//         ' !important;letter-spacing:1px;text-decoration:none;font-weight: bold;font-family:arial!important;visibility: hidden;top:' +
//         pixel_from_start +
//         'px;display: inline-block;border-radius:6px;width:280px;overflow: hidden;position:fixed!important;' +
//         (accessibility_rtl ? 'right' : 'left') +
//         ':' +
//         pixel_from_side +
//         'px;box-sizing: border-box;text-align:right!important;margin: 0 auto;-webkit-transition: background-color 0.3s;transition: background-color 0.3s;-webkit-box-shadow: 0px 0px 5px 0px #000000;-moz-box-shadow: 0px 0px 5px 0px #000000;box-shadow: 0px 0px 5px 0px #000000;}'),
//       (c += '.btn_accessibility_action span{font-size:' + r + ';}'),
//       (c += '.btn_accessibility_action img{vertical-align:top;margin-left:8px;width:auto;}'),
//       (c += '.btn_accessibility_action strong {color: ' + e + ';-webkit-transition: all 0.3s;transition: all 0.3s;}'),
//       (c += '.btn_accessibility_action:hover{-webkit-box-shadow: 0px 0px 5px 1px #000000;-moz-box-shadow: 0px 0px 5px 1px #757575;box-shadow: 0px 0px 5px 1px #757575;}'),
//       (c += 'a.btn_accessibility_action:hover,a.btn_accessibility_action:focus{font-size:' + r + ';text-decoration:underline;background-color:' + a + ' !important;outline:0;}'),
//       (c += '.btn_accessibility_action_active{background-color:' + a + ' !important;outline:0;}'),
//       (c += 'a.btn_accessibility_action:hover div,a.btn_accessibility_action:focus div,.btn_accessibility_action_active div{}'),
//       (c += '.a_gray{-webkit-transition: color 0.3s;transition: color 0.3s;}'),
//       (c += '.a_gray:hover,.a_gray:focus,.a_gray_active{color:' + o + ' !important;text-decoration:underline !important;outline:0;}'),
//       (c += '.btn_accessibility_action .accessibility_action_icn{font-size:22px;position:absolute;top:14px;right:10px;}'),
//       (c += '.btn_accessibility_action:hover .accessibility_action_icn,.btn_accessibility_action:focus .accessibility_action_icn,.btn_accessibility_action_active .accessibility_action_icn{right:6px;color:yellow !important;}'),
//       (c += '.btn_font_size:hover strong,.btn_font_size:focus strong{color:yellow !important;}'),
//       (c += '.a_hover_opacity:hover, .a_hover_opacity:focus {-webkit-text-shadow: 1px 1px 0px #003755;-moz-text-shadow: 1px 1px 0px #003755;box-shadow: 1px 1px 0px #003755;}'),
//       (c += '.font_size_icn_b {font-size: 19px;top: 17px;right: 8px;position: absolute;}'),
//       (c += '.font_size_icn_s {font-size: 15px;right: 21px;top: 20px;position: absolute;}'),
//       (c += '.btn_accessibility_action:hover .font_size_icn_b, .btn_accessibility_action:focus .font_size_icn_b {right: 5px;color: yellow !important;}'),
//       (c += '.btn_accessibility_action:hover .font_size_icn_s, .btn_accessibility_action:focus .font_size_icn_s {right: 18px;color: yellow !important;}'),
//       (c += '.accessibility_component {line-height: 1.1 !important;font-family:arial!important;direction:rtl;}'),
//       (c += 'img.accessibility_component {display:inline !important;}'),
//       (c += '.gray_images {-webkit-filter: grayscale(100%);filter: grayscale(100%);}'),
//       (s.innerHTML =
//         '.links_underline{text-decoration:underline  !important;}.readable_font{font-family:arial !important;}.accessibility_contrast_yellow_on_black {background:none !important;background-color:black !important;color:yellow !important;}.accessibility_contrast_yellow_on_black_a,.accessibility_contrast_yellow_on_black_a::before{background:none !important;background-color:black !important;color:yellow !important;outline:1px dashed yellow !important;}.accessibility_contrast_yellow_on_black_a:hover,.accessibility_contrast_yellow_on_black_a:focus,.accessibility_contrast_yellow_on_black_a:hover::before,.accessibility_contrast_yellow_on_black_a:focus::before{color:#ffffff !important;outline:1px dashed #ffffff !important;}.accessibility_contrast_yellow_on_black_input {background:none !important;background-color:#ffffff !important;color:#000000 !important;}.accessibility_contrast_black_on_blue {background:none !important;background-color:#c2d3fc !important;color:#000000 !important;}.accessibility_contrast_black_on_blue_a,.accessibility_contrast_black_on_blue_a::before{background:none !important;background-color:#c2d3fc !important;color:#000000 !important;outline:1px dashed #000000 !important;}.accessibility_contrast_black_on_blue_a:hover,.accessibility_contrast_black_on_blue_a:hover div,.accessibility_contrast_black_on_blue_a:hover span,.accessibility_contrast_black_on_blue_a:focus,.accessibility_contrast_black_on_blue_a:hover::before,.accessibility_contrast_black_on_blue_a:focus::before{color:#ffffff !important;outline:1px dashed #ffffff !important;background-color:#89ABFA !important;}.accessibility_contrast_black_on_blue_input {background:none !important;background-color:#ffffff !important;color:#000000 !important;}' +
//         c),
//       document.head.appendChild(s);
//   } catch (e) {}
// }
// function KeepFontSizeDefault() {
//     jQuery("body,div,span,table,tr,td,h1,h2,h3,h4,h5,h6,p,ol,ul,li,strong,label,a,label,font").each(function (e) {
//         try {
//             var t = jQuery(this).css("font-size");
//             if ("" != t && 4 == t.length && 2 == (t = (t = t.replace("px", "")).replace("pt", "")).length) {
//                 var i = jQuery(this).css("font-size").replace(t, "");
//                 jQuery(this).attr("data-font-size", t), jQuery(this).attr("data-font-size-type", i);
//             }
//             var a = jQuery(this).css("line-height");
//             "" != a && -1 != a.indexOf("px") && parseInt(a.replace("px", "")) < 30 && jQuery(this).attr("data-line-height", a);
//         } catch (e) {}
//     }),
//         jQuery(".accessibility_component").removeAttr("data-font-size"),
//         jQuery(".accessibility_component").removeAttr("data-font-size-type"),
//         jQuery(".accessibility_component").removeAttr("data-line-height");
// }
// var current_font_size_level = 1;
// function FontSizeXl() {
//     try {
//         setCookie("accessibility_font_size", "xl", 1);
//     } catch (e) {}
//     jQuery(".a_gray").removeClass("a_gray_active"),
//         jQuery("#a_fs_xl").addClass("a_gray_active"),
//         jQuery("body,div,span,table,tr,td,h1,h2,h3,h4,h5,h6,p,ol,ul,li,strong,label,a,label,font").each(function (e) {
//             try {
//                 if (isElHasAttr(this, "data-font-size")) {
//                     var t = parseInt(jQuery(this).attr("data-font-size"));
//                     isNaN(t) || ((t += 8), jQuery(this).css("font-size", t + jQuery(this).attr("data-font-size-type")), jQuery(this).addClass("fs" + t + "px"));
//                 }
//                 isElHasAttr(this, "data-line-height") && jQuery(this).css("line-height", "1.2");
//             } catch (e) {
//                 console.log(e);
//             }
//         });
// }
// function FontSizeL() {
//     try {
//         setCookie("accessibility_font_size", "l", 1);
//     } catch (e) {}
//     jQuery(".a_gray").removeClass("a_gray_active"),
//         jQuery("#a_fs_l").addClass("a_gray_active"),
//         jQuery("body,div,span,table,tr,td,h1,h2,h3,h4,h5,h6,p,ol,ul,li,strong,label,a,label,font").each(function (e) {
//             try {
//                 if (isElHasAttr(this, "data-font-size")) {
//                     var t = parseInt(jQuery(this).attr("data-font-size"));
//                     (t += 4), jQuery(this).css("font-size", t + jQuery(this).attr("data-font-size-type"));
//                 }
//                 isElHasAttr(this, "data-line-height") && jQuery(this).css("line-height", "1.2");
//             } catch (e) {}
//         });
// }
// function FontSizeM() {
//     try {
//         setCookie("accessibility_font_size", "m", 1);
//     } catch (e) {}
//     jQuery(".a_gray").removeClass("a_gray_active"),
//         jQuery("#a_fs_m").addClass("a_gray_active"),
//         jQuery("body,div,span,table,tr,td,h1,h2,h3,h4,h5,h6,p,ol,ul,li,strong,label,a,label,font").each(function (e) {
//             try {
//                 if (isElHasAttr(this, "data-font-size")) {
//                     var t = parseInt(jQuery(this).attr("data-font-size"));
//                     (t += 2), jQuery(this).css("font-size", t + jQuery(this).attr("data-font-size-type"));
//                 }
//                 isElHasAttr(this, "data-line-height") && jQuery(this).css("line-height", "1.2");
//             } catch (e) {}
//         });
// }
// function FontSizeDefault() {
//     try {
//         setCookie("accessibility_font_size", "", 1);
//     } catch (e) {}
//     jQuery(".a_gray").removeClass("a_gray_active"),
//         jQuery("#a_fs_d").addClass("a_gray_active"),
//         jQuery("body,div,span,table,tr,td,h1,h2,h3,h4,h5,h6,p,ol,ul,li,strong,label,a,label,font").each(function (e) {
//             try {
//                 if (isElHasAttr(this, "data-font-size")) {
//                     var t = parseInt(jQuery(this).attr("data-font-size"));
//                     jQuery(this).css("font-size", t + jQuery(this).attr("data-font-size-type"));
//                 }
//                 isElHasAttr(this, "data-line-height") && jQuery(this).css("line-height", jQuery(this).attr("data-line-height"));
//             } catch (e) {}
//         });
// }
// function AccessibilityContrastYellowOnBlack() {
//     if (is_contrast_yellow) AccessibilityContrastYellowOnBlackReset();
//     else {
//         is_contrast_blue && AccessibilityContrastBlackOnBlueReset();
//         try {
//             setCookie("accessibility_contrast", "yellow", 1);
//         } catch (e) {}
//         jQuery("body,table,tr,h1,h2,h3,h4,h5,h6,ol,ul,li,strong,label,font").addClass("accessibility_contrast_yellow_on_black"),
//             jQuery("div,span,td,p").each(function (e) {
//                 var t = jQuery(this).css("background-image");
//                 null == t
//                     ? "" != jQuery.trim(jQuery(this).text()) && jQuery(this).addClass("accessibility_contrast_yellow_on_black")
//                     : -1 == t.indexOf("url") && "" != jQuery.trim(jQuery(this).text()) && jQuery(this).addClass("accessibility_contrast_yellow_on_black");
//             }),
//             jQuery("a").each(function (e) {
//                 var t = jQuery(this).css("background-image");
//                 null == t ? jQuery(this).addClass("accessibility_contrast_yellow_on_black_a") : -1 == t.indexOf("url") && jQuery(this).addClass("accessibility_contrast_yellow_on_black_a");
//             }),
//             jQuery("input").addClass("accessibility_contrast_yellow_on_black_input"),
//             jQuery(".accessibility_component").removeClass("accessibility_contrast_yellow_on_black"),
//             jQuery("a.accessibility_component").removeClass("accessibility_contrast_yellow_on_black_a"),
//             (is_contrast_blue = !(is_contrast_yellow = !0)),
//             jQuery("#accessibility_action4").addClass("btn_accessibility_action_active"),
//             jQuery("#accessibility_action3").removeClass("btn_accessibility_action_active");
//     }
// }
// function AccessibilityContrastBlackOnBlue() {
//     if (is_contrast_blue) AccessibilityContrastBlackOnBlueReset();
//     else {
//         is_contrast_yellow && AccessibilityContrastYellowOnBlackReset();
//         try {
//             setCookie("accessibility_contrast", "blue", 1);
//         } catch (e) {}
//         jQuery("body,table,tr,h1,h2,h3,h4,h5,h6,ol,ul,li,strong,label,font").addClass("accessibility_contrast_black_on_blue"),
//             jQuery("div,span,td,p").each(function (e) {
//                 var t = jQuery(this).css("background-image");
//                 null == t
//                     ? "" != jQuery.trim(jQuery(this).text()) && jQuery(this).addClass("accessibility_contrast_black_on_blue")
//                     : -1 == t.indexOf("url") && "" != jQuery.trim(jQuery(this).text()) && jQuery(this).addClass("accessibility_contrast_black_on_blue");
//             }),
//             jQuery("a").each(function (e) {
//                 var t = jQuery(this).css("background-image");
//                 null == t ? jQuery(this).addClass("accessibility_contrast_black_on_blue_a") : -1 == t.indexOf("url") && jQuery(this).addClass("accessibility_contrast_black_on_blue_a");
//             }),
//             jQuery("input").addClass("accessibility_contrast_black_on_blue_input"),
//             jQuery(".accessibility_component").removeClass("accessibility_contrast_black_on_blue"),
//             jQuery("a.accessibility_component").removeClass("accessibility_contrast_black_on_blue_a"),
//             (is_contrast_yellow = !(is_contrast_blue = !0)),
//             jQuery("#accessibility_action3").addClass("btn_accessibility_action_active"),
//             jQuery("#accessibility_action4").removeClass("btn_accessibility_action_active");
//     }
// }
// function AccessibilityContrastYellowOnBlackReset() {
//     try {
//         setCookie("accessibility_contrast", "", 1);
//     } catch (e) {}
//     jQuery("body,div,span,table,tr,td,h1,h2,h3,h4,h5,h6,p,ol,ul,li,strong,label,font").removeClass("accessibility_contrast_yellow_on_black"),
//         jQuery("a").removeClass("accessibility_contrast_yellow_on_black_a"),
//         jQuery("input").removeClass("accessibility_contrast_yellow_on_black_input"),
//         jQuery(".accessibility_component").removeClass("accessibility_contrast_yellow_on_black"),
//         jQuery("a.accessibility_component").removeClass("accessibility_contrast_yellow_on_black_a"),
//         (is_contrast_yellow = !1),
//         jQuery("#accessibility_action4").removeClass("btn_accessibility_action_active");
// }
// function AccessibilityContrastBlackOnBlueReset() {
//     try {
//         setCookie("accessibility_contrast", "", 1);
//     } catch (e) {}
//     jQuery("body,div,span,table,tr,td,h1,h2,h3,h4,h5,h6,p,ol,ul,li,strong,label,font").removeClass("accessibility_contrast_black_on_blue"),
//         jQuery("a").removeClass("accessibility_contrast_black_on_blue_a"),
//         jQuery("input").removeClass("accessibility_contrast_black_on_blue_input"),
//         jQuery(".accessibility_component").removeClass("accessibility_contrast_black_on_blue"),
//         jQuery("a.accessibility_component").removeClass("accessibility_contrast_black_on_blue_a"),
//         (is_contrast_blue = !1),
//         jQuery("#accessibility_action3").removeClass("btn_accessibility_action_active");
// }
// function ReadableFont() {
//     if (is_readable_font) ReadableFontReset();
//     else {
//         jQuery("body,div,span,table,tr,td,h1,h2,h3,h4,h5,h6,p,ol,ul,li,a,input,select,option,strong,font").addClass("readable_font"), jQuery("#accessibility_action7").addClass("btn_accessibility_action_active");
//         try {
//             setCookie("readable_font", "1", 1);
//         } catch (e) {}
//         jQuery(".accessibility_component").removeClass("readable_font"), (is_readable_font = !0);
//     }
// }
// function ReadableFontReset() {
//     jQuery("body,div,span,table,tr,td,h1,h2,h3,h4,h5,h6,p,ol,ul,li,a,input,select,option,strong").removeClass("readable_font"), jQuery("#accessibility_action7").removeClass("btn_accessibility_action_active"), (is_readable_font = !1);
//     try {
//         setCookie("readable_font", "", 1);
//     } catch (e) {}
// }
// function LinksUnderline() {
//     if (is_links_underline) LinksUnderlineReset();
//     else {
//         jQuery("a").addClass("links_underline"), jQuery("#accessibility_action5").addClass("btn_accessibility_action_active");
//         try {
//             setCookie("links_underline", "1", 1);
//         } catch (e) {}
//         jQuery("a.accessibility_component").removeClass("links_underline"), (is_links_underline = !0);
//     }
// }
// function LinksUnderlineReset() {
//     jQuery("#accessibility_action5").removeClass("btn_accessibility_action_active"), (is_links_underline = !1), jQuery("a").removeClass("links_underline");
//     try {
//         setCookie("links_underline", "", 1);
//     } catch (e) {}
// }
// function BlockAnimation() {
//     if (is_animation_blocked) UnBlockAnimation();
//     else {
//         jQuery("*").stop(!0), (jQuery.fx.off = !0), jQuery("#accessibility_action6").addClass("btn_accessibility_action_active");
//         var e = document.createElement("style");
//         (e.type = "text/css"),
//             (e.innerHTML =
//                 "* {/*CSS transitions*/ -o-transition-property: none !important; -moz-transition-property: none !important; -ms-transition-property: none !important; -webkit-transition-property: none !important;  transition-property: none !important;/*CSS transforms*/  -o-transform: none !important; -moz-transform: none !important;   -ms-transform: none !important;  -webkit-transform: none !important;   transform: none !important;  /*CSS animations*/   -webkit-animation: none !important;   -moz-animation: none !important;   -o-animation: none !important;   -ms-animation: none !important;   animation: none !important;}"),
//             document.getElementsByTagName("head")[0].appendChild(e),
//             (is_animation_blocked = !0);
//         try {
//             setCookie("is_animation_blocked", "1", 1);
//         } catch (e) {}
//     }
// }
// function UnBlockAnimation() {
//     jQuery("#accessibility_action6").removeClass("btn_accessibility_action_active");
//     try {
//         setCookie("is_animation_blocked", "", 1);
//     } catch (e) {}
//     is_animation_blocked && (window.location.href = window.location.href);
// }
// function GrayImages() {
//     if (is_gray_images) GrayImagesReset();
//     else {
//         jQuery("body,div,span,table,tr,td,h1,h2,h3,h4,h5,h6,p,ol,ul,li,a,input,select,option,strong").addClass("gray_images"), jQuery("#accessibility_action10").addClass("btn_accessibility_action_active");
//         try {
//             setCookie("gray_images", "1", 1);
//         } catch (e) {
//             console.log("Error setCookie: " + e);
//         }
//         jQuery(".accessibility_component").removeClass("gray_images"), (is_gray_images = !0);
//     }
// }
// function GrayImagesReset() {
//     jQuery("body,div,span,table,tr,td,h1,h2,h3,h4,h5,h6,p,ol,ul,li,a,input,select,option,strong").removeClass("gray_images"), jQuery("#accessibility_action10").removeClass("btn_accessibility_action_active"), (is_gray_images = !1);
//     try {
//         setCookie("gray_images", "", 1);
//     } catch (e) {
//         console.log("Error setCookie: " + e);
//     }
// }
// function AccessibilityReset() {
//     FontSizeDefault(), AccessibilityContrastBlackOnBlueReset(), AccessibilityContrastYellowOnBlackReset(), LinksUnderlineReset(), ReadableFontReset(), UnBlockAnimation(), GrayImagesReset(), jQuery(":focus").blur(), StartAccessibility();
// }
// function DetectMobile() {
//     return !!(
//         navigator.userAgent.match(/Android/i) ||
//         navigator.userAgent.match(/webOS/i) ||
//         navigator.userAgent.match(/iPhone/i) ||
//         navigator.userAgent.match(/iPad/i) ||
//         navigator.userAgent.match(/iPod/i) ||
//         navigator.userAgent.match(/BlackBerry/i) ||
//         navigator.userAgent.match(/Windows Phone/i)
//     );
// }
